/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { chequePaymentsGetChequePaymentAudits } from '../fn/cheque-payments/cheque-payments-get-cheque-payment-audits';
import { ChequePaymentsGetChequePaymentAudits$Params } from '../fn/cheque-payments/cheque-payments-get-cheque-payment-audits';
import { chequePaymentsGetChequePaymentsWithPagination } from '../fn/cheque-payments/cheque-payments-get-cheque-payments-with-pagination';
import { ChequePaymentsGetChequePaymentsWithPagination$Params } from '../fn/cheque-payments/cheque-payments-get-cheque-payments-with-pagination';
import { chequePaymentsGetResellerChequePaymentsWithPagination } from '../fn/cheque-payments/cheque-payments-get-reseller-cheque-payments-with-pagination';
import { ChequePaymentsGetResellerChequePaymentsWithPagination$Params } from '../fn/cheque-payments/cheque-payments-get-reseller-cheque-payments-with-pagination';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfPaginatedListOfGetChequePaymentsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-cheque-payments-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetResellerChequePaymentsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-reseller-cheque-payments-with-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ChequePaymentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `chequePaymentsGetChequePaymentAudits()` */
  static readonly ChequePaymentsGetChequePaymentAuditsPath = '/ChequePayments/GetChequePaymentAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chequePaymentsGetChequePaymentAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chequePaymentsGetChequePaymentAudits$Response(params: ChequePaymentsGetChequePaymentAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return chequePaymentsGetChequePaymentAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chequePaymentsGetChequePaymentAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chequePaymentsGetChequePaymentAudits(params: ChequePaymentsGetChequePaymentAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.chequePaymentsGetChequePaymentAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `chequePaymentsGetChequePaymentsWithPagination()` */
  static readonly ChequePaymentsGetChequePaymentsWithPaginationPath = '/ChequePayments/GetChequePaymentsWithPagination';

  /**
   * Get ChequePayments WithPagination for users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chequePaymentsGetChequePaymentsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chequePaymentsGetChequePaymentsWithPagination$Response(params: ChequePaymentsGetChequePaymentsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetChequePaymentsWithPaginationDto>> {
    return chequePaymentsGetChequePaymentsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ChequePayments WithPagination for users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chequePaymentsGetChequePaymentsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chequePaymentsGetChequePaymentsWithPagination(params: ChequePaymentsGetChequePaymentsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetChequePaymentsWithPaginationDto> {
    return this.chequePaymentsGetChequePaymentsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetChequePaymentsWithPaginationDto>): CustomResultOfPaginatedListOfGetChequePaymentsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `chequePaymentsGetResellerChequePaymentsWithPagination()` */
  static readonly ChequePaymentsGetResellerChequePaymentsWithPaginationPath = '/ChequePayments/GetResellerChequePaymentsWithPagination';

  /**
   * دریافت لیست چک های فروشنده فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chequePaymentsGetResellerChequePaymentsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chequePaymentsGetResellerChequePaymentsWithPagination$Response(params: ChequePaymentsGetResellerChequePaymentsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerChequePaymentsWithPaginationDto>> {
    return chequePaymentsGetResellerChequePaymentsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست چک های فروشنده فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chequePaymentsGetResellerChequePaymentsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chequePaymentsGetResellerChequePaymentsWithPagination(params: ChequePaymentsGetResellerChequePaymentsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetResellerChequePaymentsWithPaginationDto> {
    return this.chequePaymentsGetResellerChequePaymentsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerChequePaymentsWithPaginationDto>): CustomResultOfPaginatedListOfGetResellerChequePaymentsWithPaginationDto => r.body)
    );
  }

}
